import Vue from 'vue'
class Filters {
  constructor() {
    this.filterPrice()
    this.productImg()
  }

  // 过滤价格，把分转成元
  // 用法 {{ 12300 | filterPrice(2) }} -> 123.00
  private filterPrice(): any {
    Vue.filter('filterPrice', function (value: string, toFixedNum = 0): string {
      if (!value) return (0).toFixed(toFixedNum)
      const convertValue = parseInt(value) / 100
      return toFixedNum ? convertValue.toFixed(toFixedNum) : String(convertValue)
    })
  }

  private productImg(): any {
    Vue.filter('productImg', function (value: string) {
      if (!value) {
        return ''
      }
      const arr = value.split('!')[0]
      if (arr) {
        return `https://pic${
          Math.floor(Math.random() * Math.floor(6)) + 1
        }.zhuanstatic.com/zhuanzh/${arr}`
      } else {
        return ''
      }
    })
  }
}
export default new Filters()
